<!-- <button mat-raised-button
        matTooltip="{{info}}"
        aria-label="Button that displays a tooltip when focused or hovered over">
i
</button> -->


<span ><img alt="information" class="info-icon" src="assets/images/info-icon.svg" matTooltip="{{info}}"></span>

